import React, { useMemo } from 'react';
import { Dialog } from 'primereact/dialog';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Tag } from 'primereact/tag';
import { useGetInvoiceDetailByGroupIdQuery } from '../../../../../api/endpoints/dealerInvoiceEntryApi';

const ClaimsDetailDialog = ({ visible, onHide, groupId, th }) => {
    const { data: response, isLoading, isFetching } = useGetInvoiceDetailByGroupIdQuery(
        { groupId, pageNumber: 1, pageSize: 100 },
        { skip: !visible || !groupId }
    );

    const claimsItems = useMemo(() => {
        if (!response) return [];
        
        const data = response.data || response;
        if (data?.items && Array.isArray(data.items)) {
            return data.items;
        }
        if (Array.isArray(data)) {
            return data;
        }
        return [];
    }, [response]);

    const totalAmount = useMemo(() => {
        return claimsItems.reduce((sum, item) => sum + (item.totalPrice || 0), 0);
    }, [claimsItems]);

    // DÜZELTME: Sabit 'TRY' yerine rowData.currency kullanılıyor
    const currencyBody = (rowData) => {
        const val = rowData.totalPrice ?? 0;
        const cur = rowData.currency || 'TRY';
        try {
            return new Intl.NumberFormat('tr-TR', { 
                style: 'currency', 
                currency: cur 
            }).format(val);
        } catch {
            return `${val} ${cur}`;
        }
    };


    return (
        <Dialog
            header={
                <div className="flex align-items-center gap-2">
                    <i className="pi pi-list text-primary text-xl"></i>
                    <span>{th('dealerInvoice.claimsDetail.title') || 'Talep Detayları'}</span>
                    {groupId && (
                        <Tag value={groupId} severity="info" className="ml-2" />
                    )}
                </div>
            }
            visible={visible}
            style={{ width: '50vw', minWidth: '600px' }}
            onHide={onHide}
            modal
            maximizable
        >
            {(isLoading || isFetching) ? (
                <div className="flex justify-content-center align-items-center p-5">
                    <ProgressSpinner style={{ width: '50px', height: '50px' }} />
                </div>
            ) : claimsItems.length > 0 ? (
                <div className="flex flex-column gap-3">
                    {/* Tablo */}
                    <DataTable
                        value={claimsItems}
                        className="p-datatable-gridlines"
                        stripedRows
                        rowHover
                        emptyMessage={th('common.noRecords')}
                    >
                        <Column
                            field="warrClaimsNo"
                            header={th('dealerInvoice.claimsDetail.claimNumber')}
                            style={{ minWidth: '200px' }}
                            body={(rowData) => (
                                <span className="font-medium">
                                    {rowData.warrClaimsNo || '-'}
                                </span>
                            )}
                        />
                        <Column
                            field="totalPrice"
                            header={th('dealerInvoice.totalPrice')}
                            body={currencyBody}
                            align="right"
                            style={{ minWidth: '150px' }}
                        />
                    </DataTable>
                </div>
            ) : (
                <div className="flex flex-column align-items-center justify-content-center p-5 text-500">
                    <i className="pi pi-inbox text-5xl mb-3"></i>
                    <span className="text-lg">
                        {th('dealerInvoice.claimsDetail.noData') || 'Bu grup için talep kaydı bulunamadı.'}
                    </span>
                </div>
            )}
        </Dialog>
    );
};

export default ClaimsDetailDialog;
